<template>
  <div>
    <b-form>
      <b-form-group id="input-group-1" :label="$t('text_announcement_form.subject')" label-for="input-1">
        <b-form-input
          :disabled="disabled"
          id="input-1"
          v-model="form.otsikko"
          required
          :placeholder="$t('text_announcement_form.subject')">
        </b-form-input>
      </b-form-group>

      <template v-for="(item, index) in this.systemLangs">
        <label v-bind:key="'labelkey' + index" v-bind:for="'ta' + index">{{ $t('text_announcement_form.text') }} ({{ $t(item.lang) }}):</label>
        <b-form-textarea
          v-bind:key="'key' + index"
          :disabled="disabled"
          v-model="form.tiedoteTextList[item.id]"
          v-bind:id="'ta' + index"
          :placeholder="$t('text_announcement_form.text')"
          rows="4"
          max-rows="6">
        </b-form-textarea>
      </template>
    </b-form>

    <SelectList
      :label="$t('text_announcement_form.ann_type')"
      :options="typeOptions"
      :value="form.tyyppi"
      @select="onSelect"
      :searchable="false"
      :clearable="false"
      :disabled="false"
    />
  </div>
</template>

<script>
export default {
  name: 'AnnouncementEditForm',
  props: {
    editordata: Object,
    creatingNew: Boolean,
  },
  data() {
    return {
      announcementType: [
        { text: this.$t('text_announcement_form.type.1'), value: 1 },
        { text: this.$t('text_announcement_form.type.5'), value: 5 },
      ],
      systemLangs: [],
      form: {},
      show: true,
      disabled: false,
      defaultFormData: {
        tunnus: -1,
        externalId: null,
        tiedoteTextList: {
          1: '',
        },
        otsikko: '',
        kelpoisuusalkaa: '',
        kelpoisuusloppuu: '',
        tyyppi: 1,
        organisaatio: null,
        htiedoteid: null,
        hstatus: null,
        kiinnitystyyppi: null,
        terminal: null,
      },
      typeOptions: [
        {
          id: 1,
          label: this.$t('text_announcement_form.type.1'),
          icon: 'info-square',
        },
        {
          id: 5,
          label: this.$t('text_announcement_form.type.5'),
          icon: 'exclamation-triangle',
        },
      ],
    }
  },
  created: function () {
    if (this.editordata != null) {
      this.form = JSON.parse(JSON.stringify(this.editordata))
    } else {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
    }

    this.$store.dispatch('getSystemParameters').then(
      (result) => {
        var langs = []
        Object.keys(result.system_languages).forEach((item) =>
          langs.push({ id: item, lang: result.system_languages[item] })
        )
        this.systemLangs = langs
      },
      () => {
        /* TODO: Ei virheentarkistusta! */
      }
    )
  },
  watch: {
    editordata: function () {
      if (this.editordata == null) {
        this.resetForm()
      } else {
        this.form = JSON.parse(JSON.stringify(this.editordata))
        this.disabled = false
      }
    },
    creatingNew: function () {
      if (this.creatingNew) {
        this.newAnnouncement()
      }
    },
  },
  methods: {
    newAnnouncement: function () {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
      this.disabled = false
    },
    resetForm: function () {
      this.form = JSON.parse(JSON.stringify(this.defaultFormData))
      this.disabled = false
    },
    collectFormData: function () {
      return JSON.parse(JSON.stringify(this.form))
    },
    onSelect(value) {
      this.form.tyyppi = value
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
textarea {
  line-height: 1.5 !important;
  padding: 5px 10px !important;
  font-size: 15px;
 
  margin-bottom: 15px;
}
</style>
